import axios from 'axios';
import store from '@/store';
import { Message } from 'element-ui';
import { openLoginDialogWithMessage } from '@/utils/tool';

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000,
});

// const controller = new AbortController();

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const res = response.data;
    res.status = parseInt(res.status);

    if (res.status !== 200) {
      Message({
        message: `操作出错：${res.msg}`,
        type: 'error',
        duration: 5 * 1000,
      });

      // 101: 未登录
      if (res.status == 101) {
        store.dispatch('resetToken');
        openLoginDialogWithMessage();
      }

      return Promise.reject({ msg: `操作出错：${res.msg}` });
    } else {
      // 200: 正常
      return res;
    }
  },
  (error) => {
    // 接口报错
    console.log('response error: ', error);
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

// 请求拦截器（token鉴权）
instance.interceptors.request.use(
  (config) => {
    // 不需要token鉴权的接口
    if (!config.authRequired) return config;

    // 需要token鉴权的接口
    const token = store.state.token;
    if (token) {
      // token 放到请求头
      config.headers.Authorization = token;
    } else {
      console.log('没有token，取消请求');
      // config.signal = controller.signal;
      // controller.abort();
      // openLoginDialogWithMessage();
      // return Promise.reject({ msg: '请先登录' });
    }

    return config;
  },
  (error) => {
    console.log('request error: ', error);
    return Promise.reject(error);
  },
);

export default instance;
